export enum AttractionCategoryEnum {
    MUSEUM = 'museum',
    TEMPLE_CHURCH = 'temple_church',
    ARCHITECTURE_LANDMARK = 'architecture_landmark',
    PALACE_FORTRESS = 'palace_fortress',
    ARCHAEOLOGICAL_SITE = 'archaeological_site',
    PARK_GARDEN = 'park_garden',
    VIEWPOINT = 'viewpoint',
    SQUARE = 'square',
    STREET_DISTRICT = 'street_district',
    BRIDGE = 'bridge',
    MARKET = 'market',
    CEMETERY_NECROPOLIS = 'cemetery_necropolis',
    THEATER_CULTURAL_VENUE = 'theater_cultural_venue',
    MONUMENT_MEMORIAL = 'monument_memorial',
    CANAL_WATERFRONT = 'canal_waterfront',
    TRANSPORT_LANDMARK = 'transport_landmark',
    STADIUM = 'stadium',
    ZOO_AQUARIUM = 'zoo_aquarium',
    GALLERY = 'gallery',
    ENTERTAINMENT = 'entertainment',
    NATURAL_SITE = 'natural_site',
    /**
     * Legacy bucket. New cards use a physical category and the `unusual` theme.
     * Existing rows stay as they are.
     */
    UNUSUAL_PLACE = 'unusual_place',
}
